/*
 * @Author: cn1994
 * @Date: 2025-01-14 17:52:29
 * @LastEditors: cn1994
 * @LastEditTime: 2025-01-14 18:00:21
 * @Description: file content
 */
export default {
  bind(el, binding, vnode) {
    let wrapperDown = false
    let wrapperUp = false
    if (!binding.value) return
    const handleMousedown = (event) => {
      try {
        wrapperDown = event.target.classList.contains('el-dialog__wrapper')
      } catch (error) {
        console.log(error)
      }
    };
    el.addEventListener('mousedown', handleMousedown);
    el._dialogWrapperMousedownHandler = handleMousedown;

    const handleMouseup = (event) => {
      try {
        wrapperUp = event.target.classList.contains('el-dialog__wrapper')
        if (wrapperDown && wrapperUp) {
          binding.value()
        }
      } catch (error) {
        console.log(error)
      }
    };
    el.addEventListener('mouseup', handleMouseup);
    el._dialogWrapperMouseupHandler = handleMouseup
  },

  unbind(el) {
    el.removeEventListener('mousedown', el._dialogWrapperMousedownHandler); // 清理事件监听
    el.removeEventListener('mouseup', el._dialogWrapperMouseupHandler); // 清理事件监听
  },
};